import type { SupportTicketCategory, SupportTicketStatus } from '@/api/support';

type SupportBadgeVariant =
    | 'default'
    | 'secondary'
    | 'destructive'
    | 'brand'
    | 'success'
    | 'warning'
    | 'info'
    | 'neutral'
    | 'outline';

export const SUPPORT_CATEGORY_LABELS: Record<SupportTicketCategory, string> = {
    bug: 'Problema técnico',
    question: 'Dúvida de uso',
    billing: 'Assinatura e pagamento',
    account: 'Conta e acesso',
    other: 'Outro assunto',
};

export const SUPPORT_CATEGORY_OPTIONS = Object.entries(SUPPORT_CATEGORY_LABELS).map(
    ([value, label]) => ({
        value: value as SupportTicketCategory,
        label,
    }),
);

export const SUPPORT_STATUS_BADGE_VARIANTS: Record<SupportTicketStatus, SupportBadgeVariant> = {
    waiting_support: 'warning',
    waiting_user: 'info',
    closed: 'neutral',
};

export const getSupportStatusLabel = (
    status: SupportTicketStatus,
    perspective: 'user' | 'agent' = 'user',
) => {
    if (status === 'waiting_support') return 'Aguardando suporte';
    if (status === 'waiting_user') {
        return perspective === 'agent' ? 'Aguardando psicólogo' : 'Aguardando sua resposta';
    }

    return 'Fechado';
};

export const formatSupportDate = (value: string) => {
    return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(new Date(value));
};
